import React, { FC } from 'react';
import clsx from 'clsx';
import { Typography, OutlinedInput } from '@mui/material';
import StyledBox, {
  StyledMenuItem,
  StyledSelectInput,
} from 'views/rebranded-module/common/components/UI/FilterDropdown/FilterDropdown.styles';
import { RiArrowDownSLine } from 'react-icons/ri';
import theme from 'lib/config/theme';

const MenuProps = {
  disableScrollLock: true,
  PaperProps: {
    sx: {
      width: 250,
      backgroundColor: theme.palette.secondary.dark,
      border: `1px solid ${theme.palette.divider[7]}`,
      borderRadius: theme.spacing(1),
      minWidth: theme.spacing(22.5),
      backgroundImage: 'unset',
      backdropFilter: 'blur(8px)',
      overflow: ' hidden',
      '& .MuiList-root': {
        maxHeight: 300,
        p: 0.5,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: theme.spacing(1),
        },
        '&::-webkit-scrollbar-track': {
          background: 'transparent',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: theme.palette.grey[700],
          borderRadius: theme.spacing(1),
          border: '1px solid transparent',
          backgroundClip: 'content-box',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: theme.palette.grey[500],
        },
        // Firefox only
        '@-moz-document url-prefix()': {
          scrollbarWidth: 'thin',
          scrollbarColor: `${theme.palette.grey[700]} transparent`,
        },
      },
    },
  },
  MenuListProps: {
    style: {
      paddingTop: 0,
    },
  },
  anchorOrigin: {
    vertical: 'bottom' as const,
    horizontal: 'left' as const,
  },
  transformOrigin: {
    vertical: 'top' as const,
    horizontal: 'left' as const,
  },
};

const FilterDropdown: FC<any> = (props) => {
  const {
    filterList,
    handleChange,
    icon,
    isLast,
    className,
    rightIcon,
    MenuPropsOverride,
  } = props;
    const mergedMenuProps = {
    ...MenuProps,
    ...MenuPropsOverride,
    PaperProps: {
      ...MenuProps.PaperProps,
      ...MenuPropsOverride?.PaperProps,
      sx: {
        ...MenuProps.PaperProps.sx,               
        ...MenuPropsOverride?.PaperProps?.sx,
      },
    },
  };
  return (
    <StyledBox className={clsx(className, { FDLastDropdown: isLast })}>
      <StyledSelectInput
        className="FDSelectInput"
        displayEmpty
        value={filterList.selectedValue ?? ''}
        onChange={(e) => {
          if (e.target.value) {
            handleChange(e, filterList.type);
          }
        }}
        disabled={filterList.disabled}
        MenuProps={mergedMenuProps}
        IconComponent={() => null}
        input={
          <OutlinedInput
            startAdornment={icon || <RiArrowDownSLine />}
            endAdornment={rightIcon || null}
          />
        }>
        {/* Placeholder item */}
        <StyledMenuItem value="" className="d-none">
          {filterList.title}
        </StyledMenuItem>

        {filterList.list.map((listItem) => (
          <StyledMenuItem
            key={listItem.id}
            value={
              filterList.valueKey
                ? listItem[filterList.valueKey]
                : listItem.name
            }
            disabled={listItem.disabled}>
            <Typography component="p" variant="body2" className="FDMenuItemText">
              {listItem.name}
            </Typography>
          </StyledMenuItem>
        ))}
      </StyledSelectInput>
    </StyledBox>
  );
};

export { FilterDropdown };
